const resources = {
    freeReturns: 'Retours gratuits',
    exclusions: 'voir les détails et les exceptions*.',
    allPurchases: 'sur tous les achats*.'
};

module.exports = function getResource(label) {
    return resources[label];
};
